const LOAD_WIDGETS = (state, payload) => {
    state.widgets = payload;
};

export default {
    LOAD_WIDGETS,
};
